export default __webpack_public_path__ + "static/media/argentan8.e7252d2a.jpg";